export default class VTextInput {
    input;
    constructor(input) {
        this.input = input;
    }
    pushCustomError(message) {
        this.input.errorMessages.push(message);
    }
    clearErrors() {
        this.input.errorMessages.splice(0, this.input.errorMessages.length);
    }
    clearCustomError(message) {
        let indexOfCustomMessage = this.input.errorMessages.indexOf(message);
        if (indexOfCustomMessage !== -1)
            this.input.errorMessages.splice(indexOfCustomMessage, 1);
    }
}
